export class UserBaseState {
  activeUserId: string;
  activeClientUserId: string;
  /**
   * When true, `client` / `clientUser` search requests ask the API to sync its
   * read model before querying. Needed when the identity behind the session has
   * just changed server-side (ZCP pool claim on registration), otherwise the
   * async search endpoints can still answer with the pre-claim userId.
   */
  syncBeforeQuery: boolean;

  constructor() {
    this.activeUserId = undefined;
    this.activeClientUserId = undefined;
    this.syncBeforeQuery = false;
  }
}

export interface UserPasswordTokenResponse {
  accessToken: string;
  author: {
    authorId: string;
    authorType: string;
  };
  expiresAt: string;
  expiresIn: number;
  refreshToken: string | null;
  sudoUntil: string
  tokenType: string
  twoFAMethods: string[];
  twoFAVerified: true;
  userId: string
}
